import { useEffect, useState } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import InjectedCheckoutForm from "./CheckoutForm";
import { Payment } from "@mui/icons-material";
import PaymentService from "@root/services/PaymentService";
import { Grid } from "@mui/material";
import StripeCardPayment from "@containers/stripe/StripeCard";
import QueryString from "query-string";
import { useDispatch } from "react-redux";

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const PUB_KEY = `${process.env.STRIPE_PUB_KEY}`;
const stripePromise = loadStripe(PUB_KEY);

export default function Stripe(props) {
  const [message, setMessage] = useState("");
  const [loading, setIsLoading] = useState("");

  const dispatch = useDispatch();

  const queryParams = QueryString.parse(window.location.search);
  const { amountInSmallestUnit = 200, currency = "GBP" } = queryParams;
  const { handlePayment } = props;

  const options = {
    mode: "payment",
    currency: "usd",
    amount: 1099,
  };

  useEffect(() => handlePayment.startOrder(), []);

  async function handleIntent() {
    try {
      const response = await PaymentService.createStripeIntent({
        amountInSmallestUnit,
        currency,
      });
      console.log("Payment intent created", { response });
      return { clientSecret: response?.intentId };
    } catch (error) {
      console.error("There was a problem with the fetch operation:", error);
      throw error;
    }
  }

  return (
    <Elements stripe={stripePromise} options={options}>
      <Grid container spacing={5}>
        <Grid xs={12} item>
          <StripeCardPayment
            setMessage={setMessage}
            setIsLoading={setMessage}
            handleIntent={handleIntent}
            message={message}
            {...props}
          />
        </Grid>
      </Grid>
    </Elements>
  );
}
